import { FC } from 'react'

import { calculateTimeBlock } from 'utils/generateTimeArray'
import { getCalendarEventTypeColors } from 'utils/color'
import { convert24HourTo12Hour } from 'utils/convertHour'

import { CalendarViewValue, ICalendarEvent, ICalendarEventType } from 'interface/calendar'

import { format } from 'date-fns'

const TIME_BLOCK_HEIGHT = 36

interface EventCardProps {
  event: ICalendarEvent
  view: CalendarViewValue
  groupTotal: number
  groupIndex: number
  selectedTypes: ICalendarEventType[]
  onClick: () => void
}

const EventCard: FC<EventCardProps> = ({
  event,
  view,
  groupTotal,
  groupIndex,
  selectedTypes,
  onClick
}) => {
  const eventTimeBlock = calculateTimeBlock(event.end_at) - calculateTimeBlock(event.start_at)

  return (
    <>
      {
        (event.is_canceled === 'false' && selectedTypes.filter((item: ICalendarEventType) => item.id === event.event_type)[0]) && 
          <div
            className="absolute w-full p-1 rounded overflow-hidden cursor-pointer"
            style={{
              color: getCalendarEventTypeColors(event.event_type).dark,
              background: getCalendarEventTypeColors(event.event_type).light,
              width: `calc(${100 * (groupTotal - groupIndex) / groupTotal}% - 1px)`,
              height: TIME_BLOCK_HEIGHT * eventTimeBlock - 1,
              top: TIME_BLOCK_HEIGHT * calculateTimeBlock(event.start_at),
              right: 0,
              border: groupIndex > 0 ? '1px solid white' : '',
            }}
            onClick={onClick}
          >
            {view === 'day' ? (
              <>
                {eventTimeBlock > 1 && (
                  <p className="text-xs font-light">
                    { convert24HourTo12Hour(event.start_at) } - { convert24HourTo12Hour(event.end_at) }
                  </p>
                )}
                <p className="text-sm font-medium">
                  {event.title}
                </p>
                {eventTimeBlock > 1 && (
                  <p className="text-sm font-normal">
                    {event.description}
                  </p>
                )}
              </>
            ) : (
              <>
                <p
                  className={`text-[12px] font-medium ${eventTimeBlock === 1 ? 'truncate' : 'overflow-hidden'}`}
                  style={{
                    maxHeight: eventTimeBlock === 1 ? 'unset' : TIME_BLOCK_HEIGHT * (eventTimeBlock - 1)
                  }}
                >
                  {event.title}
                </p>
                {eventTimeBlock > 1 && (
                  <p className="text-[12px] font-light">
                    {format(new Date(`${event.start_date} ${event.start_at}`), 'hh:mm a')}
                  </p>
                )}
              </>
            )}
          </div>
      }
    </>
  )
}

export default EventCard
